import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { t } from '../../../../modules/infra/i18n';
import {
  FILTER_TODAY,
  FILTER_ONE_WEEK,
  FILTER_FOUR_WEEKS,
  FILTER_ONE_YEAR,
  FILTER_WEEK_TIL_TODAY,
  FILTER_MONTH_TIL_TODAY,
  FILTER_QUARTER_TIL_TODAY,
  FILTER_YEAR_TIL_TODAY,
  FILTER_CUSTOM,
} from '../constants';

const getFilterDisplayText = (filter) => {
  switch (filter) {
    case FILTER_TODAY:
      return t('common:range_filter.today');
    case FILTER_ONE_WEEK:
      return t('common:range_filter.one_week');
    case FILTER_FOUR_WEEKS:
      return t('common:range_filter.four_weeks');
    case FILTER_ONE_YEAR:
      return t('common:range_filter.one_year');
    case FILTER_WEEK_TIL_TODAY:
      return t('common:range_filter.week_til_today');
    case FILTER_MONTH_TIL_TODAY:
      return t('common:range_filter.month_til_today');
    case FILTER_QUARTER_TIL_TODAY:
      return t('common:range_filter.quarter_til_today');
    case FILTER_YEAR_TIL_TODAY:
      return t('common:range_filter.year_til_today');
    case FILTER_CUSTOM:
      return t('common:range_filter.custom');
    default:
      return filter;
  }
};

const RangeButtons = ({ filters, onFilterChange, disabled, selectedFilter }) => (
  <div className="c-input-group">
    {filters.map((item) => (
      <button
        key={item}
        className={classnames(
          `c-btn c-btn--medium u-1/${filters.length}-medium-and-down`,
          'medium-and-down-ph-- u-text-center c-btn--outline c-btn--active-branding',
          { 'is-active': item === selectedFilter }
        )}
        onClick={onFilterChange(item)}
        type="button"
        disabled={disabled}
        data-automation-id={`button:timeRange:${item}`}
      >
        {getFilterDisplayText(item)}
      </button>
    ))}
  </div>
);

RangeButtons.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedFilter: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RangeButtons.defaultProps = {
  disabled: false,
  selectedFilter: null,
};

export default RangeButtons;
